import PropTypes from 'prop-types';

export const TActivity = {
  idactivity: PropTypes.string,
  active: PropTypes.bool,
  activity: PropTypes.string,
  description: PropTypes.string,
  rules: PropTypes.string,
};
